import { SuccessfulApiResponse } from "@eryxcoop/appyx-comm";

export default class PurchaseFrequencyResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                purchase_frequency: {
                    rows: [
                        { customer_business_name: "BREAD FACTORY SA", delivery_site_code: "03", delivery_site_name: "BOULAN PALERMO", purchase_count: 24, days_since_last_purchase: 3, status: "ok", mean: "7.20", min: "2", max: "15", p10: "3.00", p90: "12.00" },
                        { customer_business_name: "BREAD FACTORY SA", delivery_site_code: "04", delivery_site_name: "BOULAN NÚÑEZ", purchase_count: 15, days_since_last_purchase: 9, status: "ok", mean: "10.30", min: "4", max: "21", p10: "5.00", p90: "18.00" },
                        { customer_business_name: "BREAD FACTORY SA", delivery_site_code: "05", delivery_site_name: "BOULAN CABALLITO", purchase_count: 11, days_since_last_purchase: 41, status: "overdue", mean: "9.50", min: "3", max: "30", p10: "4.00", p90: "22.00" },
                        { customer_business_name: "BREAD FACTORY SA", delivery_site_code: "01", delivery_site_name: "BOULAN UGARTECHE", purchase_count: 7, days_since_last_purchase: 28, status: "warning", mean: "17.17", min: "5", max: "40", p10: "6.00", p90: "34.00" },
                        { customer_business_name: "BREAD FACTORY SA", delivery_site_code: "02", delivery_site_name: "BOULAN SINCLAIR", purchase_count: 1, days_since_last_purchase: 12, status: "unknown", mean: null, min: null, max: null, p10: null, p90: null },
                    ],
                },
            },
            errors: [],
        };
    }

    // content() {
    //     return PurchaseFrequencyResponse.defaultResponse().object;
    // }

    purchaseFrequency() {
        const purchaseFrequency = this.content().purchase_frequency;
        return {
            rows: purchaseFrequency.rows.map((row) => this._adaptRow(row)),
        };
    }

    _adaptRow(row) {
        return {
            customerBusinessName: row.customer_business_name,
            deliverySiteCode: row.delivery_site_code,
            deliverySiteName: row.delivery_site_name,
            purchaseCount: row.purchase_count,
            daysSinceLastPurchase: row.days_since_last_purchase,
            status: row.status,
            mean: this._toNumber(row.mean),
            min: this._toNumber(row.min),
            max: this._toNumber(row.max),
            p10: this._toNumber(row.p10),
            p90: this._toNumber(row.p90),
        };
    }

    _toNumber(value) {
        return value == null ? null : Number(value);
    }
}
